import * as types from './index';

export const termsFetchAction = (data) => { // USED IN SUPERADMIN ONLY 
    return {
    type: types.TERMS_FETCH ,
    data
    }
};

export const termsAddAction = (data) => { // USED IN SUPERADMIN ONLY 
    return {
    type: types.TERMS_ADD,
    data
    }
};


export const termsUpdateAction = (data) => { // USED IN SUPERADMIN ONLY 
    return {
    type: types.TERMS_UPDATE,
    data
    }
};

export const termsLoadAction = (data) => { // USED IN AFFILIATES AND CLIENT LOGIN  
    return {
    type: types.TERMS_LOAD,
    data
    }
};

export const termsAcceptAction = (data) => { // USED IN AFFILIATES AND CLIENT LOGIN  
    return {
    type: types.TERMS_ACCEPT,
    data
    }
};

